import { Box, Typography } from "@mui/material";
import React from "react";
import IconComponent from "../../../common/components/IconComponent";
import { IExpressionEvaluatorContext } from "../../../ExpressionsModule";
import useObservedExpression from "../../Hooks/useObservedExpression";
import { PropertyDisplayModel } from "../../Models/PropertyDisplayModel";

type DataDisplayPropertyLabelProps = {
  property: PropertyDisplayModel;
  context: IExpressionEvaluatorContext;
  rowDirection?: boolean;
};

const DataDisplayPropertyLabel: React.FC<DataDisplayPropertyLabelProps> = ({ property, context, rowDirection }) => {
  const [isRequired] = useObservedExpression<boolean>(property.Required, context, `DataDisplayPropertyLabel-${property.Label}-Required`, (value) => !!value);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        minWidth: !rowDirection ? 120 : undefined,
      }}
    >
      {property.IconName && <IconComponent iconName={property.IconName} size="small" />}
      <Typography
        variant="body2"
        sx={{
          color: rowDirection ? "text.secondary" : undefined,
        }}
      >
        {property.Label}
        {isRequired && (
          <Box component="span" sx={{ color: "error.main", ml: 0.25 }}>
            *
          </Box>
        )}
      </Typography>
    </Box>
  );
};

export default DataDisplayPropertyLabel;
